import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";
import {EmptySearchParamsFilterModel} from "../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchParamsModel} from "../../shared/models/search/params/search-params.model";

export class CollectionSearchParamsModel extends SearchParamsModel {
    public constructor(
        public collection: ProductCollectionsEnum,
        public sorting: string,
        pageNumber: number,
        filter: EmptySearchParamsFilterModel
    ) {
        super(pageNumber, filter);
    }
}
